module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "6%",
      "margin-left": "1%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("我们将为您跳转至用户引导页面，同时为您启动MOA AI诊修工具修复您的问题...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("若AI诊修工具启动不成功，请您根据引导页面进行手动修复.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("（We will redirect you to the user guide and launch the MOA AI Agent tool to resolve the issue...")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("If the tool fails to start, please refer to the guide for manual repair）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d745d8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai.vue
// module id = 653
// module chunks = 1